import React from "react";

export default function Loader() {
  return (
    <div className="loader_bg">
      <div className="loader_bg_img">
        <img src="/images/loader.png" alt="" />
      </div>
    </div>
  );
}
